import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children, allowedUserTypes }) => {
  const { user } = useAuth();

  // ❌ not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ❌ userType not allowed
  if (allowedUserTypes && !allowedUserTypes.includes(user.userTypeId)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;